var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLists = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.76589 4C1.78876 4 1 4.81357 1 5.82143C1 6.82929 1.78876 7.64286 2.76589 7.64286C3.74301 7.64286 4.53177 6.82929 4.53177 5.82143C4.53177 4.81357 3.74301 4 2.76589 4Z",
  fill: "#32373C"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.66555 5.78348C6.66555 5.28051 7.06086 4.87277 7.5485 4.87277H22.1171C22.6047 4.87277 23 5.28051 23 5.78348C23 6.28646 22.6047 6.6942 22.1171 6.6942H7.5485C7.06086 6.6942 6.66555 6.28646 6.66555 5.78348Z",
  fill: "#32373C"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.66555 12.4621C6.66555 11.9591 7.06086 11.5513 7.5485 11.5513H22.1171C22.6047 11.5513 23 11.9591 23 12.4621C23 12.965 22.6047 13.3728 22.1171 13.3728H7.5485C7.06086 13.3728 6.66555 12.965 6.66555 12.4621Z",
  fill: "#32373C"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.66555 19.1406C6.66555 18.6377 7.06086 18.2299 7.5485 18.2299H22.1171C22.6047 18.2299 23 18.6377 23 19.1406C23 19.6436 22.6047 20.0513 22.1171 20.0513H7.5485C7.06086 20.0513 6.66555 19.6436 6.66555 19.1406Z",
  fill: "#32373C"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M1 12.5C1 11.4921 1.78876 10.6786 2.76589 10.6786C3.74301 10.6786 4.53177 11.4921 4.53177 12.5C4.53177 13.5079 3.74301 14.3214 2.76589 14.3214C1.78876 14.3214 1 13.5079 1 12.5Z",
  fill: "#32373C"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M1 19.1786C1 18.1829 1.78876 17.3571 2.76589 17.3571C3.74301 17.3571 4.53177 18.1829 4.53177 19.1786C4.53177 20.1743 3.73124 21 2.76589 21C1.80054 21 1 20.1743 1 19.1786Z",
  fill: "#32373C"
})));
export { SvgLists as ReactComponent };
export default __webpack_public_path__ + "images/lists.svg";